<!-- If volume exists, handle its type -->
<ng-container *ngIf="volume">
  <ng-container [ngSwitch]="volume.type">
    <small
      class="text-small-caps blue"
      *ngSwitchCase="VOLUME_TYPE.GENERATED_ESTIMATE"
      [matTooltip]="GENERATED_TOOLTIP">
      {{ 'VOLUME.GENERATED' | translate }}
    </small>

    <small
      class="text-small-caps green"
      *ngSwitchCase="VOLUME_TYPE.ESTIMATE"
      [matTooltip]="ESTIMATE_TOOLTIP">
      {{ 'VOLUME.ESTIMATE' | translate }}
    </small>
  </ng-container>
</ng-container>

<!-- If volume is null, show default "Estimate" -->
<small
  class="text-small-caps green"
  *ngIf="!volume"
  [matTooltip]="ESTIMATE_TOOLTIP">
  {{ 'VOLUME.ESTIMATE' | translate }}
</small>
